"use strict";exports.__esModule=true;exports.default=void 0;var _default={"*.*.*":{"*.disappearing":[{finalAttr:{opacity:0},slot:"initial",callback:function callback(){this.hide()}}]}};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/chart/_internal/common.animation.js
// module id = uH80
// module chunks = 5